// Recovered compiled webpack factory 53127. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { Q: () => n });
  let n = (0, i(12115).createContext)({
    transformPagePoint: (t) => t,
    isStatic: !1,
    reducedMotion: "never",
  });
}
